import api from '../../services/service_invoice'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'
import moment from 'moment'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      zone_list: [],
      data_list: [],
      zone: '',
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      month: '',
      modal_start: 1,
      modal_end: 0
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.searchInvoice()
    },
    getZoneAll () {
      var obj = {
        search: '',
        active_page: 1,
        per_page: 100000000
      }
      api.getZone(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    searchInvoice () {
      sessionStorage.invoiceActiveMonth = this.month
      sessionStorage.invoiceActivePage = this.activePage
      var obj = {
        search: this.search,
        zone: this.zone,
        date: this.month,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      this.$store.state.isLoading = true
      api.searchInvoice(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.data_list = result.data.pagination
            this.allItem = result.data.count
            this.modal_end = this.allItem
          } else {
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    export_invoice () {
      $('#PrintInvoiceCenter').modal('hide')
      var obj = {
        search: this.search,
        zone: this.zone,
        date: this.month,
        active_page: Math.ceil(parseInt(this.modal_start) / (parseInt(this.modal_end) - parseInt(this.modal_start - 1))),
        per_page: parseInt(this.modal_end) - parseInt(this.modal_start - 1)
      }
      console.log(obj)
      this.$store.state.isLoading = true
      api.searchInvoice(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            document.getElementsByName(
              'data_invoice'
            )[0].value = JSON.stringify(result.data.pagination)
            document.getElementsByName('config')[0].value =
              sessionStorage.config
            this.$refs.printInvoceAll.submit()
            this.modal_start = 1
            this.modal_end = this.allItem
          } else {
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    cancelInvoice (row) {
      const invoiceId = row && (row.invoice_id || row.invoice_docno)
      const invoiceDoc = row && row.invoice_docno ? row.invoice_docno : invoiceId
      if (!invoiceId) {
        Swal.fire('ยกเลิกใบแจ้งหนี้', 'ไม่พบข้อมูล invoice_id', 'warning')
        return
      }

      if (row && parseFloat(row.invoice_payment) > 0) {
        Swal.fire('ยกเลิกใบแจ้งหนี้', 'ใบแจ้งหนี้นี้มีการรับชำระแล้ว กรุณายกเลิกใบเสร็จก่อน', 'warning')
        return
      }

      Swal.fire({
        title: 'ยกเลิกใบแจ้งหนี้?',
        text: `ท่านต้องการยกเลิกเอกสารเลขที่ ${invoiceDoc} ใช่หรือไม่ ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่',
        reverseButtons: true
      }).then((result) => {
        if (!result.value) return

        this.$store.state.isLoading = true
        api.cancelInvoice(
          { invoice_id: row.invoice_id },
          this.header,
          res => {
            if (res.response === true) {
              Swal.fire('ยกเลิกใบแจ้งหนี้', res.message || 'success', 'success')
              this.searchInvoice()
            } else {
              Swal.fire('ยกเลิกใบแจ้งหนี้', res.message || 'error', 'warning')
            }
            this.$store.state.isLoading = false
          },
          err => {
            Swal.fire('ยกเลิกใบแจ้งหนี้', 'เกิดข้อผิดพลาด', 'error')
            console.log(err)
            this.$store.state.isLoading = false
          }
        )
      })
    }
  },
  mounted () {
    moment.locale('th')
    this.getZoneAll()
    this.activePage = parseInt(sessionStorage.invoiceActivePage)
    if (sessionStorage.invoiceActiveMonth === '') {
      this.month = this.dateMonth(new Date())
      sessionStorage.invoiceActiveMonth = this.month
    } else {
      this.month = sessionStorage.invoiceActiveMonth
    }
    // eslint-disable-next-line no-undef
    this.searchInvoice()
    $('body').on('hidden.bs.modal', '.modal', function () {
      // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/invoice.js